"use client"

import { useEffect, useState } from "react"
import "./About.css"

const About = ({ language }) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)
  }, [])

  const translations = {
    en: {
      heroTitle: "About Hon. Abubakar Kabir Abubakar",
      heroSubtitle:
        "Member Representing Bichi Federal Constituency & Chairman House of Representatives Committee on Appropriations",
      profileTitle: "Hon. Engr. (Dr) Abubakar Kabir Abubakar",
      profileSubtitle:
        "Member Representing Bichi Federal Constituency & Chairman House of Representatives Committee on Appropriations",
      biographyTitle: "Biography",
      biographyText:
        "Abubakar Kabir Abubakar Bichi was born on October 2, 1981, into a family with a history of public service in Bichi, Kano State. His father was a former commissioner and member of the Kano State House of Assembly, while his grandfather and great-grandfather were Bichi royalty.",
      educationTitle: "Education",
      educationText:
        "He attended Hagagawa Primary School, Bichi, Government Junior Secondary School Bichi, before proceeding to Dawakin Tofa Science College for his Senior Secondary School Certificate. He obtained a bachelor's degree in interdisciplinary studies from the New York Institute of Technology and a master's degree in energy management from same university.",
      politicalCareerTitle: "Political Career",
      politicalCareerText:
        "Abba Bichi's political career began with his election to the Federal House of Representatives in 2019, representing the Bichi Federal Constituency in Kano State under the platform of the All Progressives Congress (APC). He served as the Chairman of the House Committee on Works during the 9th Assembly (2019-2023). In the current assembly, he is the Chairman of the House Committee on Appropriation.",
      committeeRoleTitle: "What does the Chairman Committee On Appropriations do?",
      committeeRoleDescription:
        "As Chairman of the House Committee on Appropriations, Hon. Abubakar Kabir Abubakar oversees the federal budget process, ensuring transparent allocation of resources and monitoring government expenditure across all ministries, departments, and agencies.",
      whyAkaTitle: "Why AKA Bichi?",
      educationalSupport: "Educational Support",
      educationalSupportText:
        "The Kabiru Abubakar Bichi Foundation has sponsored hundreds of students within Nigeria and abroad for various degree programs. This support includes scholarships, payment of exam fees, and distributing educational materials.",
      legislativeImpact: "National Legislative Impact",
      legislativeImpactText:
        "In his capacity as Chairman of the House Committee on Works (2019–2023) and Appropriations (2023–present), Bichi has overseen critical federal projects across the country. He has also sponsored bills, including one for a University of Medicine and Health Sciences in Bichi.",
      awardRecognition: "Award Recognition",
      awardRecognitionText:
        "Bichi received the 'Reps of the Year 2024' award from Democracy Heroes Award Africa, recognizing his contributions to democratic norms and community development.",
      constituentPerception: "Constituent and Supporter Perception",
      constituentPerceptionText:
        "Supporters and constituents praise Bichi for his accessibility, humility, and dedication to service.",
      philanthropicEfforts: "Philanthropic Efforts",
      philanthropicEffortsText:
        "Besides educational support, Bichi is also involved in humanitarian endeavors within his constituency, including providing resources for the elderly.",
      politicalStanding: "National Political Standing",
      politicalStandingText:
        "As the Chairman of the House Committee on Appropriations, he holds a high-profile position that commands significant influence in federal budget implementation and national development projects.",
      canDo: "What He Can Do:",
      canDoList: [
        "Review and approve federal budget allocations",
        "Monitor government expenditure and ensure accountability",
        "Oversee implementation of appropriated funds",
        "Conduct budget oversight sessions with ministries",
        "Ensure equitable distribution of federal resources",
      ],
      cannotDo: "What He Cannot Do:",
      cannotDoList: [
        "Directly allocate funds without legislative approval",
        "Override constitutional budget processes",
        "Make unilateral budget decisions",
        "Bypass due process in appropriations",
        "Act outside the scope of legislative authority",
      ],
    },
    ha: {
      heroTitle: "Game da Malam Abubakar Kabir Abubakar",
      heroSubtitle: "Wakilin Mazabar Bichi da Shugaban Kwamitin Kasafin Kudi na Majalisar Wakilai",
      profileTitle: "Malam Injiniya (Dokta) Abubakar Kabir Abubakar",
      profileSubtitle: "Wakilin Mazabar Bichi da Shugaban Kwamitin Kasafin Kudi na Majalisar Wakilai",
      biographyTitle: "Tarihin Rayuwa",
      biographyText:
        "Abubakar Kabir Abubakar Bichi an haife shi a ranar 2 ga Oktoba, 1981, a cikin iyali mai tarihin hidimar jama'a a Bichi, Jihar Kano. Mahaifinsa tsohon kwamishina ne kuma memba na Majalisar Jihar Kano, yayin da kakansa da babban kakansa sarakuna ne na Bichi.",
      educationTitle: "Ilimi",
      educationText:
        "Ya halarci Makarantar Firamare ta Hagagawa, Bichi, Makarantar Sakandare ta Gwamnati Bichi, kafin ya ci gaba zuwa Kwalejin Kimiyya ta Dawakin Tofa don Takardar Shaidar Sakandare. Ya sami digiri na farko a fannin karatun daban-daban daga Cibiyar Fasaha ta New York kuma ya sami digiri na biyu a fannin sarrafa makamashi daga wannan jami'a.",
      politicalCareerTitle: "Aikin Siyasa",
      politicalCareerText:
        "Aikin siyasar Abba Bichi ya fara da zaɓensa zuwa Majalisar Wakilai ta Tarayya a 2019, yana wakiltar Mazabar Bichi a Jihar Kano a ƙarƙashin jam'iyyar All Progressives Congress (APC). Ya yi aiki a matsayin Shugaban Kwamitin Ayyuka na Majalisar a lokacin Majalisar ta 9 (2019-2023). A majalisar ta yanzu, shi ne Shugaban Kwamitin Kasafin Kudi na Majalisar.",
      committeeRoleTitle: "Menene Shugaban Kwamitin Kasafin Kudi ke yi?",
      committeeRoleDescription:
        "A matsayinsa na Shugaban Kwamitin Kasafin Kudi na Majalisar, Malam Abubakar Kabir Abubakar yana kula da tsarin kasafin kudin tarayya, yana tabbatar da rarraba albarkatu cikin gaskiya da kuma sa ido kan kashe kudin gwamnati a duk ma'aikatun, sassan da hukumomin.",
      whyAkaTitle: "Me yasa AKA Bichi?",
      educationalSupport: "Tallafin Ilimi",
      educationalSupportText:
        "Gidauniyar Kabiru Abubakar Bichi ta tallafa wa daruruwan dalibai a cikin Najeriya da waje don shirye-shiryen digiri daban-daban. Wannan tallafin ya hada da tallafin karatu, biyan kudin jarrabawa, da rarraba kayan ilimi.",
      legislativeImpact: "Tasirin Majalisa na Kasa",
      legislativeImpactText:
        "A matsayinsa na Shugaban Kwamitin Ayyuka na Majalisar (2019–2023) da Kasafin Kudi (2023–har yanzu), Bichi ya kula da muhimman ayyukan tarayya a fadin kasar. Ya kuma gabatar da kudurori, ciki har da na kafa Jami'ar Likitanci da Kimiyyar Lafiya a Bichi.",
      awardRecognition: "Karramawa da Kyaututtuka",
      awardRecognitionText:
        "Bichi ya karbi lambar yabo ta 'Wakilin Shekara 2024' daga Democracy Heroes Award Africa, don gane gudummawarsa ga ka'idojin dimokuradiyya da ci gaban al'umma.",
      constituentPerception: "Ra'ayin Mazaba da Magoya Baya",
      constituentPerceptionText:
        "Magoya baya da mazaba suna yaba wa Bichi saboda saukin isa gare shi, tawali'u, da sadaukarwa ga hidima.",
      philanthropicEfforts: "Ayyukan Taimako",
      philanthropicEffortsText:
        "Baya ga tallafin ilimi, Bichi yana kuma shiga cikin ayyukan jin kai a cikin mazabarsa, ciki har da samar da albarkatu ga tsofaffi.",
      politicalStanding: "Matsayin Siyasa na Kasa",
      politicalStandingText:
        "A matsayinsa na Shugaban Kwamitin Kasafin Kudi na Majalisar, yana da babban matsayi wanda ke da tasiri mai yawa a aiwatar da kasafin kudi na tarayya da ayyukan ci gaban kasa.",
      canDo: "Abin da Zai Iya Yi:",
      canDoList: [
        "Duba da amincewa da rabon kasafin kudin tarayya",
        "Sa ido kan kashe kudin gwamnati da tabbatar da lissafi",
        "Kula da aiwatar da kudaden da aka keɓe",
        "Gudanar da zaman sa ido kan kasafin kudi tare da ma'aikatun",
        "Tabbatar da rarraba albarkatun tarayya cikin adalci",
      ],
      cannotDo: "Abin da Ba Zai Iya Yi Ba:",
      cannotDoList: [
        "Rarraba kudade kai tsaye ba tare da amincewar majalisa ba",
        "Ketare tsarin kasafin kudi na kundin tsarin mulki",
        "Yanke shawara kan kasafin kudi shi kadai",
        "Ketare tsarin da ya dace a rarraba kudade",
        "Yin aiki a waje da ikon majalisa",
      ],
    },
  }

  const t = translations[language]

  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className={`about-hero-content ${isVisible ? "fade-in" : ""}`}>
          <h1>{t.heroTitle}</h1>
          <p>{t.heroSubtitle}</p>
        </div>
      </section>

      {/* Main Content */}
      <div className="about-content">
        {/* Profile Section */}
        <section className={`profile-section side-by-side ${isVisible ? "slide-in-up" : ""}`}>
          <div className="profile-image-container">
            <img
              src="/images/aboutpic.jpg"
              alt="Hon. Abubakar Kabir Abubakar"
              className="profile-image"
            />
          </div>
          <div className="profile-text-accent">
            <h2 className="profile-title">{t.profileTitle}</h2>
            <p className="profile-subtitle">{t.profileSubtitle}</p>
          </div>
        </section>

        {/* Biography Section */}
        <section className={`bio-section ${isVisible ? "slide-in-left" : ""}`}>
          <h2 className="section-title">{t.biographyTitle}</h2>
          <p className="bio-text">{t.biographyText}</p>
        </section>

        {/* Education Section */}
        <section className={`bio-section ${isVisible ? "slide-in-right" : ""}`}>
          <h2 className="section-title">{t.educationTitle}</h2>
          <p className="bio-text">{t.educationText}</p>
        </section>

        {/* Political Career Section */}
        <section className={`bio-section ${isVisible ? "slide-in-left" : ""}`}>
          <h2 className="section-title">{t.politicalCareerTitle}</h2>
          <p className="bio-text">{t.politicalCareerText}</p>
        </section>

        {/* Committee Role Section */}
        <section className={`committee-role ${isVisible ? "fade-in" : ""}`}>
          <div className="committee-content">
            <h2 className="committee-title">{t.committeeRoleTitle}</h2>
            <p className="committee-description">{t.committeeRoleDescription}</p>

            <div className="responsibilities-list">
              <div className="responsibility-item">
                <h5>{t.canDo}</h5>
                <ul>
                  {t.canDoList.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
              <div className="responsibility-item">
                <h5>{t.cannotDo}</h5>
                <ul>
                  {t.cannotDoList.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Why AKA Bichi Section */}
        <section className={`bio-section ${isVisible ? "slide-in-up" : ""}`}>
          <h2 className="section-title">{t.whyAkaTitle}</h2>

          <div className="achievements-grid">
            <div className="achievement-card">
              <h4>{t.educationalSupport}</h4>
              <p>{t.educationalSupportText}</p>
            </div>
            <div className="achievement-card">
              <h4>{t.legislativeImpact}</h4>
              <p>{t.legislativeImpactText}</p>
            </div>
            <div className="achievement-card">
              <h4>{t.awardRecognition}</h4>
              <p>{t.awardRecognitionText}</p>
            </div>
            <div className="achievement-card">
              <h4>{t.constituentPerception}</h4>
              <p>{t.constituentPerceptionText}</p>
            </div>
            <div className="achievement-card">
              <h4>{t.philanthropicEfforts}</h4>
              <p>{t.philanthropicEffortsText}</p>
            </div>
            <div className="achievement-card">
              <h4>{t.politicalStanding}</h4>
              <p>{t.politicalStandingText}</p>
            </div>
          </div>
        </section>

        {/* Final Profile Section */}
        <section className={`final-profile ${isVisible ? "slide-in-up" : ""}`}>
          <h2 className="profile-title" style={{ textAlign: "center", marginBottom: "1rem" }}>
            {t.profileTitle}
          </h2>
          <p className="profile-subtitle" style={{ textAlign: "center", marginBottom: "2rem" }}>
            {t.profileSubtitle}
          </p>
          <img
            src="/images/aboutpic1.jpeg"
            alt="Hon. Abubakar Kabir Abubakar"
            style={{
              width: "100%",
              height: "407px",
              objectFit: "cover",
              borderRadius: "15px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
            }}
          />
        </section>
      </div>
    </div>
  )
}

export default About
